// Material UI
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutlined';

import NotificationsIcon from '@mui/icons-material/NotificationsNoneRounded';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

import GroupIcon from '@mui/icons-material/Group';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';

import SchoolIcon from '@mui/icons-material/School';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationOffIcon from '@mui/icons-material/LocationOff';

import MusicNoteIcon from '@mui/icons-material/MusicNote';
import MusicOffIcon from '@mui/icons-material/MusicOff';

import PaymentIcon from '@mui/icons-material/Payment';

const getNotificationIcon = (templateName: string | undefined) => {
  if (!templateName) {
    return <NotificationsIcon />;
  }

  switch (templateName.toString()) {
    case 'acceptedToTeachAtEventTime':
      return <CheckIcon />;

    case 'connectionRemoved':
    case 'declinedToTeachAtEventTime':
    case 'declinedRequest':
    case 'removedAsTeacherEventTimes':
      return <ClearIcon />;

    case 'chatFrom':
      return <ChatBubbleIcon />;

    case 'requestOnBehalfOfOrganization':
    case 'requestAcceptedToJoinOrganization':
      return <GroupAddIcon />;

    case 'requestDeclinedToJoinOrganization':
      return <PersonAddDisabledIcon />;

    case 'removedFromOrganization':
    case 'userLeftTheOrganization':
      return <RemoveCircleOutlineIcon />;

    case 'requestToTeachAtTheirEvent':
    case 'requestToTeachAtYourEvent':
    case 'requestToBecomeConnectedTeacher':
    case 'requestToBeTeacher':
      return <SchoolIcon />;

    case 'requestOnBehalfOfLocationToBeHost':
    case 'requestHostAtYourLocation':
    case 'requestHostLocationAtYourLocation':
    case 'acceptToBecomeHost':
      return <LocationOnIcon />;

    case 'locationRemovedFromEventTime':
    case 'locationRemoved':
    case 'hostLocationRemoved':
      return <LocationOffIcon />;

    case 'songApproval':
      return <MusicNoteIcon />;

    case 'suggestionAdded':
      return <MusicNoteIcon />;

    case 'songDenied':
      return <MusicOffIcon />;

    case 'paymentSucceeded':
    case 'paymentFailed':
      return <PaymentIcon />;

    case 'acceptedParent':
      return <GroupIcon />;
  }
  return <NotificationsIcon />;
};

export default getNotificationIcon;
